import { FormGroup, ValidatorFn } from '@angular/forms';

export const RECENT_PREGNANCY_MAX_GESTATION_WEEK = 8;

export const isRecentPregnancyRelevant = (gestationWeek: unknown): boolean =>
  gestationWeek !== null &&
  gestationWeek !== undefined &&
  gestationWeek !== '' &&
  Number(gestationWeek) < RECENT_PREGNANCY_MAX_GESTATION_WEEK;

// Applied on `serviceInformation`: the recent pregnancy question (NIPPT) is
// required only when the gestation age is under 8 weeks
export function recentPregnancyValidator(): ValidatorFn {
  return (form: FormGroup) => {
    const wasPregnantControl = form.get(
      'nippt.patientHistory.anotherPregnancy.wasPregnant'
    );
    const gestationWeek = form.get(
      'shared.currentPregnancyInformation.gestationAge.week'
    ).value;

    if (
      isRecentPregnancyRelevant(gestationWeek) &&
      wasPregnantControl.value === null
    ) {
      wasPregnantControl.setErrors({ required: true });
      return null;
    }

    if (wasPregnantControl.hasError('required')) {
      delete wasPregnantControl.errors['required'];
      wasPregnantControl.updateValueAndValidity();
    }

    return null;
  };
}
